import {
  addProductViaApi,
  createCollectionApi,
  createMultiTexture,
  deleteMultipleTextures,
  deleteProductsApi,
  saveMultiTexture,
  updateMultiTexture,
  updateRetailAutomationArtwork,
  updateRetailAutomationSets,
} from '../../../api/retailAutomationApis';
import { v4 as uuidv4 } from 'uuid';
import { OPTION_TYPE } from '../../../constants/productConfiguratorConstants';
import { NAME_EXCLUDED_SPECIAL_CHARS } from '../../../constants/validationConstants';
import { apiGetLOAMappedTextures, apiPostImageOnPresignedData } from '../../../helpers/api';
import { getJson } from '../../../helpers/axiosHelper';
import { dispatcher } from '../../../helpers/projectHelper';
import { errorToastV2, warningToast } from '../../../helpers/toastHelper';
import { UnityEvent, waitForEventOnce } from '../../../helpers/unityPubSub';
import {
  initialSetSteps,
  retailAutomationActions,
  selectAllTemplates,
  selectAutomationSets,
  selectRetailAutomationId,
  selectPropDataReceivedFromUnity,
  selectTemplateId,
  selectDefaultTextureData,
  selectCurrentSelectedProduct,
  selectActiveSetDetails,
  selectArtworkDefaultCombinations,
  selectSelectedVariationProd,
  selectCardIndexClicked,
  selectHotSpotProducts,
  selectIsClearRackTriggered,
} from '../../../redux/slicers/retailAutomation/retailAutomation.slicer';
import { getAppState } from '../../../redux/store';
import { loadUnityProps } from '../../../pages/admin/curator/projectParser/loadUnityProps';
import { propsReadApi } from '../../../api/curator';
import { fetchAllPages } from '../../../helpers/apiHelper';
import { cloneDeep, isEmpty, isEqual, uniq } from 'lodash';
import {
  clearCacheFromAPI,
  getSessionStorage,
  removeDuplicatesByKey,
  removeSessionStorage,
  setSessionStorage,
  wait,
} from '../../../helpers/jsHelper';
import { addDefaultTexturesToObject } from '../../../helpers/unity/addDefaultTexturesToObject';
import { RETAIL_AUTOMATION_DELETED_PROPS_LIST } from '../../../constants/constants';
import { updateMissingTexturesInDb } from '../../Configurator/unity/objectPropertiesMethods';
import { CHANGED_MAP_PATHS__TEXTURE_MAP } from '../../../config/constant/unityConstants';
import { selectUnityLoaded } from '../../../redux/slicers/admin/curatorSlicer';
import { getGroupPropJsonFile } from '../../../pages/admin/curator/getRoomJsonFile';
import { addIdsToRequestData } from '../../admin/curator/CuratorHeader/useSaveProject';
import { LogCurator } from '../../../helpers/logEvents';
import { updateHotspotJsonApiV2, updateHotspotProductApi } from '../helper';

// Commenting this as we are using createHotspot from useRetailHotspot hook
// const createAllHotspot = async (hotspots, automationId, setData) => {
//   const copyData = JSON.parse(JSON.stringify(hotspots));
//   // Build payloads first
//   const promises = copyData?.map((hotspot, i) => {
//     const payload = {
//       name: `In-Store Location ${i + 1}`,
//       retail_automation: automationId,
//       retail_set: setData.id,
//       json_data: JSON.stringify({
//         sequence: i + 1,
//         linked_prop_object_id: hotspot.linked_prop_object_id,
//         linked_prop_object_name: hotspot.linked_prop_object_name,
//       }),
//     };
//     return createHotspotViaApi(payload).then((newData) => newData?.data);
//   });

//   // Run all in parallel
//   const results = await Promise.all(promises);

//   // Filter only valid ones
//   const allHotspotData = results.filter((data) => data?.id);
//   return allHotspotData.length === copyData.length ? allHotspotData : [];
// };

// const createAllCameras = async (hotspotInfo, automationId, setData) => {
//   const hotspotCameras = hotspotInfo.json_data?.cameraInfo;
//   if (!hotspotCameras.length) return [];
//   // for (let i = 0; i < hotsportCameras?.length; i++) {
//   //   // hotsportCameras[i]?.cameraName
//   //   const payload = {
//   //     name: 'Camera ' + (i+1),
//   //     retail_automation: automationId,
//   //     retail_set: setData.id,
//   //     hotspot: hotspotInfo?.id,
//   //     seq_no: i + 1,
//   //     camera_data: JSON.stringify(hotsportCameras[i]),
//   //     thumb: hotsportCameras[i]?.thumbnail_link,
//   //   };
//   //   const newData = await createCameraViaApi(payload);
//   //   if (newData?.data?.id) {
//   //     cameras?.push(newData?.data);
//   //   }
//   // }

//   // Bulk payload
//   // const cameraPayload = {
//   //   retail_automation: automationId,
//   //   retail_set: setData.id,
//   //   hotspot: hotspotInfo?.id,
//   //   all_camera_details: hotsportCameras.map((camera, idx) => ({
//   //     name: `Camera ${idx + 1}`,
//   //     seq_no: idx + 1,
//   //     camera_data: JSON.stringify(camera),
//   //     thumb: 'thumb.png',
//   //     is_enable: true, // idx === 0, // enable first camera
//   //   })),
//   // };

//   // Bulk creation
//   // const results = (await createBulkCameraViaApi(cameraPayload))?.data || [];

//   const newCameras = await createHotspotCamera({
//     automationId,
//     retailSetId: setData.id,
//     hotspotId: hotspotInfo?.id,
//     cameraList: hotspotCameras,
//     autoEnableFirst: true,
//   })

//   // Parallel upload of thumbnails
//   await Promise.all(
//     newCameras
//       .filter((c) => c?.camera_data?.thumbnail_link && c?.presigned_data_thumb)
//       .map(async (camera) => {
//         const thumbnailBlob = await blobUrlToFile(
//           camera.camera_data.thumbnail_link,
//           getFileNameFromUrl(camera.camera_data.thumbnail_link)
//         );
//         return apiPostImageOnPresignedData(thumbnailBlob, camera.presigned_data_thumb);
//       })
//   );

//   const cameras = newCameras.filter(Boolean);

//   if (hotspotInfo?.active) {
//     dispatcher(retailAutomationActions.setArtworkCameraRedux(cameras));
//   }

//   return cameras.length === hotspotCameras.length ? cameras : [];
// };

// const createMainProduct = async (hotspotInfo, automationId, setData) => {
//   const propId = hotspotInfo?.json_data?.linked_prop_object_id;
//   if (!propId) return [];

//   const reduxVariantData = selectAllVariantsData(getAppState());
//   let allProducts = [];

//   if (reduxVariantData?.[propId]?.length) {
//     allProducts = JSON.parse(JSON.stringify(reduxVariantData[propId]));
//   } else {
//     allProducts = await getPropVariantFromApi(propId);
//     allProducts = JSON.parse(JSON.stringify(allProducts));
//     const copyData = JSON.parse(JSON.stringify(reduxVariantData));
//     copyData[propId] = allProducts;
//     dispatcher(retailAutomationActions.setAllVariantsData(copyData));
//     // await wait(500); // keep your delay if needed
//   }

//   // Run all API calls in parallel
//   const newProds = await Promise.all(
//     allProducts.map(async (prod) => {
//       const payload = {
//         name: prod?.name,
//         retail_hotspot: hotspotInfo?.id,
//         product: prod.id,
//         thumb: prod?.thumbnail,
//       };
//       const newData = await createProductViaApi(payload);
//       if (newData?.data?.product) {
//         newData.data.product = parseInt(newData.data.product);
//       }
//       return newData?.data;
//     })
//   );

//   // Update Redux
//   let savedHotspotProducts = selectHotSpotProducts(getAppState()) || {};
//   savedHotspotProducts = JSON.parse(JSON.stringify(savedHotspotProducts));

//   dispatcher(
//     retailAutomationActions.setHotSpotProducts([
//       { id: hotspotInfo?.id, products: newProds.filter(Boolean) },
//     ])
//   );

//   return newProds.length === allProducts.length ? newProds : [];
// };

export const templateCompleted = async ({
  automationSets, 
  selectedTemplate, 
  createHotspots,
  createHotspotCameras,
  createHotspotProduct
}) => {
  dispatcher(retailAutomationActions.setFullScreenLoader(true));
  const clonedAutomationSets = JSON.parse(JSON.stringify(automationSets));
  const automationId = selectRetailAutomationId(getAppState());
  for (let i = 0; i < clonedAutomationSets.length; i++) {
    // if (clonedAutomationSets[i].selected) {
    //   const payload = {
    //     id: clonedAutomationSets[i].id,
    //     template: selectedTemplate?.id,
    //   };
    // const updatedSet = await dispatch(updateRetailAutomationSets(payload));
    // if (updatedSet?.data?.id) {
    for (let j = 0; i < clonedAutomationSets[j]?.setSteps?.length; j++) {
      if (clonedAutomationSets[i].setSteps[j].selected) {
        const setData = clonedAutomationSets[i];
        clonedAutomationSets[i].template = selectedTemplate?.id;
        const roomJson = await getJson(selectedTemplate?.room_file);
        if (roomJson?.hotspot) {
          let allHotspots = await createHotspots({ hotspots: roomJson?.hotspot, automationId, retailSetId: setData?.id });

          // merge API response (allHotspots) + roomJson.hotspot cameraInfo
          allHotspots = allHotspots
            ?.map((apiHotspot, index) => {
              const apiJsonData =
                typeof apiHotspot?.json_data === 'string'
                  ? JSON.parse(apiHotspot?.json_data)
                  : apiHotspot?.json_data || {};

              return {
                ...apiHotspot,
                json_data: {
                  ...apiJsonData, // parsed API json_data
                  cameraInfo: roomJson.hotspot[index]?.cameraInfo || [], // inject original cameraInfo
                },
              };
            })
            ?.sort((a, b) => a.json_data?.sequence - b.json_data?.sequence);

          if (allHotspots?.length) {
            dispatcher(retailAutomationActions.setShowLoadingMessage('Setting things up for you...'));
            let activeAssign = false;

            // Pre-process hotspot objects
            const processedHotspots = allHotspots.map((hotspot) => {
              const updated = { ...hotspot, label: hotspot.name, value: 'artwork' };

              if (hotspot.is_enable && !activeAssign) {
                updated.active = true;
                updated.selected = true;
                activeAssign = true;
              }

              return updated;
            });

            // Run all hotspots in parallel
            await Promise.all(
              processedHotspots.map(async (hotspot) => {
                await Promise.all([
                  createHotspotCameras({ hotspot, automationId, retailSetId: setData?.id}),
                  createHotspotProduct({ hotspot })
                  // createMainProduct(hotspot, automationId, setData),
                ]);

                dispatcher(
                  retailAutomationActions.setShowLoadingMessage(
                    'Initializing store layout and hotspot zones...'
                  )
                );
              })
            );

            // Update clonedAutomationSets after all hotspot tasks are done
            clonedAutomationSets[i].setSteps[j].subLevels = processedHotspots;
            clonedAutomationSets[i].setSteps[j].selected = false;
            clonedAutomationSets[i].setSteps[j].completed = true;
            clonedAutomationSets[i].setSteps[j].active = true;
            clonedAutomationSets[i].setSteps[j].label = selectedTemplate?.name;
          }
        } else {
          errorToastV2('Hotspot not found');
        }
      }
    }
    // }
    // }
  }
  if (shouldUpdateAutomationSetsData(clonedAutomationSets))
    await updateSetJson(clonedAutomationSets, { template: selectedTemplate?.id });
  dispatcher(
    retailAutomationActions.setShowLoadingMessage('Loading racks, camera angles, and props...')
  );
  dispatcher(retailAutomationActions.setAutomationSets(clonedAutomationSets));
  dispatcher(retailAutomationActions.setFullScreenLoader(false));
};

// export const createNewHotspot = async (allHotspotsFromJson, setData, automationId, dispatch) => {
//   const payload = {
//     retailAutomationId: automationId,
//     setId: setData?.id,
//   };
//   const dataFromApi = await getAllHotspotApis(payload);
//   const allIdsInDb = dataFromApi.map((val) => val.id);
//   const finalList = JSON.parse(JSON.stringify(allHotspotsFromJson));
//   finalList.sort((a, b) => a.id - b.id);
//   const allSelectedHotspotIds = finalList
//     .map((val) => {
//       if (val.id && !val.fromRoomJson) {
//         return val.id;
//       }
//     })
//     .filter((val) => val);
//   const idsToDelete = allIdsInDb
//     .filter((x) => !allSelectedHotspotIds.includes(x))
//     .concat(allSelectedHotspotIds.filter((x) => !allIdsInDb.includes(x)));
//   let newHotspots = [];
//   for (let i = 0; i < finalList?.length; i++) {
//     if (finalList[i]?.fromRoomJson) {
//       const payload = {
//         name: finalList[i]?.name || 'In-Store Location ' + (i + 1),
//         retail_automation: automationId,
//         retail_set: setData.id,
//         json_data: JSON.stringify({
//           cameraInfo: finalList[i].cameraInfo,
//           linked_prop_object_id: finalList[i].linked_prop_object_id,
//           linked_prop_object_name: finalList[i].linked_prop_object_name,
//         }),
//       };
//       const newData = await createHotspotViaApi(payload);
//       const copyData = JSON.parse(JSON.stringify(newData?.data));
//       copyData['cameraInfo'] = finalList[i]['cameraInfo'];
//       copyData['linked_prop_object_id'] = finalList[i]['linked_prop_object_id'];
//       copyData['linked_prop_object_name'] = finalList[i]['linked_prop_object_name'];
//       newHotspots.push(copyData);
//     } else {
//       newHotspots.push(finalList[i]);
//     }
//   }
//   idsToDelete?.map(async (val) => {
//     if (val) {
//       await deleteHotspotApi(val);
//     }
//   });
//   return newHotspots;
// };

// const getNewHotspotData = (dataCopy, index) => {
//   const copiedData = JSON.parse(JSON.stringify(dataCopy));
//   let subLevelObj = [
//     {
//       label: 'Camera Angle',
//       value: 'camera',
//       selected: index === 0 ? true : false,
//       completed: false,
//     },
//     {
//       label: 'Product',
//       value: 'product',
//       selected: false,
//       completed: false,
//     },
//     {
//       label: 'Artwork',
//       value: 'artwork',
//       selected: false,
//       completed: false,
//     },
//   ];
//   copiedData['active'] = index === 0 ? true : false;
//   copiedData['subLevels'] = subLevelObj;
//   copiedData['label'] = copiedData.name;
//   copiedData['value'] = 'hotspot';
//   copiedData['selected'] = false;
//   copiedData['canRemove'] = true;
//   return copiedData;
// };

// commenting below codes as we are not using the below function
// export const hotspotCompleted = async (
//   automationSets,
//   dispatch,
//   selectedHotspots,
//   selectedTemplate
// ) => {
//   dispatch(retailAutomationActions.setFullScreenLoader(true));
//   const dataCopy = JSON.parse(JSON.stringify(automationSets));
//   const automationId = selectRetailAutomationId(getAppState());
//   const setData = dataCopy.find((val) => val.selected);
//   let newHotspots = await createNewHotspot(selectedHotspots, setData, automationId, dispatch);
//   newHotspots.sort((a, b) => a.id - b.id);
//   const currentSetHotspot = setData.setSteps.filter((data) => data.value === 'hotspot');
//   const currentSetHotspotIds = currentSetHotspot.map((data) => data.id).filter((data) => data);
//   const newHotspotsIds = newHotspots.map((data) => data.id);

//   let hotspotCopy = [];
//   // if creating new automation
//   if (!currentSetHotspotIds?.length) {
//     hotspotCopy = newHotspots.map((data, index) => {
//       let copiedData = JSON.parse(JSON.stringify(data));
//       copiedData = getNewHotspotData(copiedData, index);
//       return copiedData;
//     });
//     for (let i = 0; i < dataCopy.length; i++) {
//       if (dataCopy[i].selected) {
//         dataCopy[i].setSteps = [dataCopy[i].setSteps[0], ...hotspotCopy];
//         dataCopy[i].setSteps[0]['active'] = false;
//       }
//     }
//   } else {
//     // existing automation
//     if (currentSetHotspotIds.sort().join(',') !== newHotspotsIds.sort().join(',')) {
//       // existing automation & differnt hotspots
//       for (let i = 0; i < newHotspots?.length; i++) {
//         let flag = false;
//         for (let j = 0; j < currentSetHotspot?.length; j++) {
//           if (newHotspots[i].id === currentSetHotspot[j].id) {
//             hotspotCopy.push(currentSetHotspot[j]);
//             flag = true;
//             break;
//           }
//         }
//         if (!flag) {
//           newHotspots[i] = getNewHotspotData(newHotspots[i]);
//           hotspotCopy.push(newHotspots[i], i);
//         }
//       }
//       for (let i = 0; i < dataCopy.length; i++) {
//         if (dataCopy[i].selected) {
//           dataCopy[i].setSteps = [dataCopy[i].setSteps[0], ...hotspotCopy];
//         }
//       }
//     }
//     for (let i = 0; i < dataCopy.length; i++) {
//       if (
//         dataCopy[i].selected &&
//         dataCopy[i]?.setSteps?.length &&
//         dataCopy[i]?.setSteps[1].subLevels?.length
//       ) {
//         dataCopy[i].setSteps[0]['completed'] = true;
//         dataCopy[i].setSteps[0]['selected'] = false;
//         dataCopy[i].setSteps[1]['selected'] = false;
//         if (dataCopy[i].setSteps[2]) {
//           dataCopy[i].setSteps[2]['selected'] = false;
//         }
//         dataCopy[i].setSteps[1].subLevels[0].selected = true;
//         break;
//       }
//     }
//   }
//   const selectedSet = dataCopy.find((data) => data.selected);
//   dispatch(retailAutomationActions.setAutomationSets(dataCopy));
//   dispatch(retailAutomationActions.setSelectedSet(selectedSet));
//   dispatch(retailAutomationActions.setSelectedHotspots(newHotspots));
//   dispatch(retailAutomationActions.setFullScreenLoader(false));
// };

// const createNewCamera = async (selectedCam, setData, automationId, hotspotInfo) => {
//   const payload = {
//     hotspot: hotspotInfo.id,
//     retail_set: setData.id,
//   };
//   const dataFromApi = await getAllHotspotCameras(payload);
//   const allIdsInDb = dataFromApi.map((val) => val.id);
//   const allSelectedCamIds = selectedCam.map((val) => val.id);
//   const idsToDelete = allIdsInDb
//     .filter((x) => !allSelectedCamIds.includes(x))
//     .concat(allSelectedCamIds.filter((x) => !allIdsInDb.includes(x)));
//   const cameraPayload = {
//     retail_automation: automationId,
//     retail_set: setData.id,
//     hotspot: hotspotInfo?.id,
//     all_camera_details: [],
//   };
//   selectedCam.forEach((values, index) => {
//     if (!values?.id) {
//       cameraPayload.all_camera_details.push({
//         name: values?.name,
//         seq_no: index + 1,
//         camera_data: JSON.stringify(values.camera_data),
//         thumb: values?.thumbnail,
//       });
//     }
//   });

//   // const newCameras = (await createBulkCameraViaApi(cameraPayload))?.data;
//   const newCameras = await createHotspotCamera({
//     automationId,
//     retailSetId: setData.id,
//     hotspotId: hotspotInfo?.id,
//     cameraList: selectedCam,
//     filterWithoutId: true,
//   })
//   idsToDelete?.map(async (val) => {
//     if (val) {
//       await deleteCameraApi(val);
//     }
//   });
//   dispatcher(retailAutomationActions.setArtworkCameraRedux(newCameras));
//   return newCameras;
// };

// We are not using cameraCompleted for now
// export const cameraCompleted = async (automationSets, dispatch, selectedCameras) => {
//   dispatch(retailAutomationActions.setFullScreenLoader(true));
//   const dataCopy = JSON.parse(JSON.stringify(automationSets));
//   const automationId = selectRetailAutomationId(getAppState());
//   const setData = dataCopy.find((val) => val.selected);
//   let flag = false;
//   for (let i = 0; i < dataCopy.length; i++) {
//     if (dataCopy[i].selected) {
//       for (let j = 0; j < dataCopy[i].setSteps.length; j++) {
//         if (dataCopy[i].setSteps[j]?.active && dataCopy[i].setSteps[j]?.subLevels?.length) {
//           const hotspotInfo = dataCopy[i].setSteps[j];
//           const newCameras = await createNewCamera(
//             selectedCameras,
//             setData,
//             automationId,
//             hotspotInfo
//           );
//           dataCopy[i].setSteps[j].subLevels[0].selected = false;
//           dataCopy[i].setSteps[j].subLevels[0].completed = true;
//           dataCopy[i].setSteps[j]['cameras'] = newCameras;
//           dataCopy[i].setSteps[j].subLevels[1].selected = true;
//           flag = true;
//           break;
//         }
//       }
//       if (!flag) break;
//     }
//   }
//   const selectedSet = dataCopy.find((data) => data.selected);
//   dispatch(retailAutomationActions.setAutomationSets(dataCopy));
//   dispatch(retailAutomationActions.setSelectedSet(selectedSet));
//   dispatch(retailAutomationActions.setFullScreenLoader(false));
// };

// export const deleteArtworkProducts = async (_idsToDelete, localProduct, str, hotspotInfo) => {
//   const idsToDelete = _idsToDelete?.filter(Boolean);

//   if (str === 'deleteAll') {
//     // delete default artworks associated with product
//     const allDefaultArtwork = selectArtworkDefaultCombinations(getAppState());
//     const copyDefaultArtwork = { item: [] };
//     const productsToDelete = localProduct
//       ?.filter((data) => idsToDelete.includes(data.id))
//       ?.map((val) => val.objectName);

//     if (productsToDelete?.length) {
//       copyDefaultArtwork.item = allDefaultArtwork?.item?.filter(
//         (data) => !productsToDelete.includes(data?.variationObjectName)
//       );
//     }
//     if (copyDefaultArtwork?.item?.length) {
//       dispatcher(retailAutomationActions.updateOnlyDefaultArtwork(copyDefaultArtwork));
//     }

//     // delete prop data recieved from unity associated with product
//     const propDataFromUnity = selectPropDataReceivedFromUnity(getAppState());
//     const copyPropDataFromUnity = propDataFromUnity?.filter(
//       (data) => !productsToDelete.includes(data.objectName)
//     );
//     if (copyPropDataFromUnity?.length) {
//       dispatcher(retailAutomationActions.updateOnlyPropDataFromUnity(copyPropDataFromUnity));
//     }
//     // productsToDelete?.map((data) => {
//     //   if (retailAutomationModule) {
//     //     retailAutomationModule.RemoveVariationProp(data);
//     //   }
//     // })
//   }

//   let apiResponse;
//   // delete from db
//   if (idsToDelete?.length) {
//     apiResponse = await Promise.all(
//       idsToDelete?.filter(Boolean)?.map(async (val) => await deleteProductsApi(val))
//     );
//   }

//   // update redux
//   const allHotspotProducts = selectHotSpotProducts(getAppState());
//   const copyProducts = JSON.parse(JSON.stringify(allHotspotProducts));
//   let currentProdList = copyProducts[hotspotInfo?.id];
//   if (currentProdList?.length) {
//     currentProdList = currentProdList?.filter((data) => !idsToDelete?.includes(data?.id));
//   }
//   copyProducts[hotspotInfo?.id] = currentProdList;
//   dispatcher(retailAutomationActions.updateHotSpotProducts(copyProducts));
//   // await wait(200);
//   return apiResponse;
// };

const createNewProducts = async (
  selectedProd,
  setData,
  automationId,
  hotspotInfo,
  localProduct,
  retailAutomationModule,
  allIdsInDb,
  deleteArtworkProducts
) => {
  clearCacheFromAPI();
  const mainProduct = selectedProd.filter((data) => data.mainProduct);
  let variantProduct = selectedProd.filter((data) => !data.mainProduct);
  variantProduct.sort((a, b) => a.id - b.id);
  const finalList = [...mainProduct, ...variantProduct];
  // const payload = {
  //   hotspot: hotspotInfo.id,
  //   retail_set: setData.id,
  // };
  // const dataFromApi = await getAllHotspotProducts(payload);
  // const allIdsInDb = dataFromApi.filter((val) => !val.duplicated_from)?.map((data) => data.id);
  // const allIdsInDb = dataFromApi?.map((data) => data.id);
  const allSelectedProdIds = finalList.map((val) => val.productdbId).filter((v) => v);
  const idsToDelete = allIdsInDb
    .filter((x) => !allSelectedProdIds.includes(x))
    .concat(allSelectedProdIds.filter((x) => !allIdsInDb.includes(x)));

  // let newProds = [];
  // for (let i = 0; i < finalList.length; i++) {
  //   if (!finalList[i]?.productdbId) {
  //     const payload = {
  //       name: finalList[i]?.name,
  //       retail_hotspot: hotspotInfo?.id,
  //       product: finalList[i].id,
  //     };
  //     const newData = await createProductViaApi(payload);
  //     newProds.push(newData?.data);
  //   } else {
  //     newProds.push(finalList[i]);
  //   }
  // }

  // const newProds = await Promise.all(finalList.map(async (item) => {
  //   if (!item?.productdbId) {
  //     const payload = {
  //       name: item?.name,
  //       retail_hotspot: hotspotInfo?.id,
  //       product: item.id,
  //     };
  //     const newData = await createProductViaApi(payload);
  //     return newData?.data;
  //   }
  //   return item;
  // }));

  // 1. Separate items that need to be created
  const productsToCreate = finalList.filter((item) => !item?.productdbId);

  // 2. Prepare the batch payload
  const payload = {
    hostpot_product_details: productsToCreate.map((item) => ({
      name: item.name,
      product: item.id,
      json_file: item.jsonFile || '', // Use item.jsonFile if available
    })),
    retail_hotspot: hotspotInfo?.id,
  };

  // 3. Call the batch creation API only if needed
  let createdProductsMap = {};
  if (payload.hostpot_product_details.length > 0) {
    const response = await addProductViaApi(payload);
    const createdProducts = response?.data || [];

    // 4. Create a map to match created products back to original by `product`
    createdProductsMap = Object.fromEntries(createdProducts.map((prod) => [prod.product, prod]));
  }

  // 5. Rebuild the final list using the original + newly created product data
  const newProds = finalList.map((item) => {
    if (!item?.productdbId && createdProductsMap[item.id]) {
      return {
        ...item,
        ...createdProductsMap[item.id], // Merge created product data
      };
    }
    return item;
  });

  if (idsToDelete?.length) {
    await deleteArtworkProducts({ idsToDelete, localProduct, str: 'deleteAll' });
  }
  return { newProds, idsToDelete };
};

export const productCompleted = async (
  automationSets,
  selectedProducts,
  localProduct,
  retailAutomationModule,
  idsInDb,
  deleteArtworkProducts
) => {
  clearCacheFromAPI();
  const dataCopy = JSON.parse(JSON.stringify(automationSets));
  const automationId = selectRetailAutomationId(getAppState());
  const setData = dataCopy.find((val) => val.selected);
  if (setData?.id && setData?.setSteps?.length && setData?.setSteps?.[0]?.subLevels?.length) {
    const activeHotspot = setData?.setSteps?.[0]?.subLevels.find(
      (data) => data.active && data.is_enable
    );
    if (activeHotspot?.id) {
      const newProducts = await createNewProducts(
        selectedProducts,
        setData,
        automationId,
        activeHotspot,
        localProduct,
        retailAutomationModule,
        idsInDb,
        deleteArtworkProducts
      );
      return newProducts;
    }
  }
  return null;
};

export const backToTemplate = (automationSets, dispatch) => {
  const dataCopy = JSON.parse(JSON.stringify(automationSets));
  for (let i = 0; i < dataCopy.length; i++) {
    if (dataCopy[i].selected) {
      dataCopy[i].setSteps[0].selected = true;
      dataCopy[i].setSteps[1].selected = false;
      dataCopy[i].setSteps[1].active = false;
      break;
    }
  }
  const selectedSet = dataCopy.find((data) => data.selected);
  dispatch(retailAutomationActions.setAutomationSets(dataCopy));
  dispatch(retailAutomationActions.setSelectedSet(selectedSet));
};

export const backToHotspot = (automationSets, dispatch) => {
  const dataCopy = JSON.parse(JSON.stringify(automationSets));
  let flag = false;
  for (let i = 0; i < dataCopy.length; i++) {
    if (dataCopy[i].selected) {
      for (let j = 0; j < dataCopy[i].setSteps.length; j++) {
        if (dataCopy[i].setSteps[j]?.active && dataCopy[i].setSteps[j]?.subLevels?.length) {
          if (j === 1) {
            dataCopy[i].setSteps[j].selected = true;
            dataCopy[i].setSteps[j - 1].selected = false;
            dataCopy[i].setSteps[j - 1].active = false;
            dataCopy[i].setSteps[j].subLevels[0].selected = false;
          } else {
            dataCopy[i].setSteps[j - 1].active = true;
            dataCopy[i].setSteps[j - 1].subLevels[2].selected = true;
            dataCopy[i].setSteps[j].subLevels[0].selected = false;
          }
          break;
        }
      }
      if (flag) break;
    }
  }
  const selectedSet = dataCopy.find((data) => data.selected);
  dispatch(retailAutomationActions.setAutomationSets(dataCopy));
  dispatch(retailAutomationActions.setSelectedSet(selectedSet));
};

export const backToCamera = (automationSets, dispatch) => {
  const dataCopy = JSON.parse(JSON.stringify(automationSets));
  let flag = false;
  for (let i = 0; i < dataCopy.length; i++) {
    if (dataCopy[i].selected) {
      for (let j = 0; j < dataCopy[i].setSteps.length; j++) {
        if (dataCopy[i].setSteps[j]?.active && dataCopy[i].setSteps[j]?.subLevels?.length) {
          dataCopy[i].setSteps[j].subLevels[0].selected = true;
          dataCopy[i].setSteps[j].subLevels[1].selected = false;
          flag = true;
          break;
        }
      }
      if (flag) break;
    }
  }
  const selectedSet = dataCopy.find((data) => data.selected);
  dispatch(retailAutomationActions.setAutomationSets(dataCopy));
  dispatch(retailAutomationActions.setSelectedSet(selectedSet));
};

export const openHotspotScreen = (automationSets, dispatch) => {
  const dataCopy = JSON.parse(JSON.stringify(automationSets));
  for (let i = 0; i < dataCopy.length; i++) {
    for (let j = 0; j < dataCopy[i].setSteps.length; j++) {
      dataCopy[i].setSteps[0].selected = false;
      dataCopy[i].setSteps[0].active = false;
      dataCopy[i].setSteps[1].selected = true;
      dataCopy[i].setSteps[1].active = true;
      for (let j = 0; j < dataCopy[i].setSteps[1].subLevels.length; j++) {
        dataCopy[i].setSteps[1].subLevels[j].selected = false;
      }
    }
  }
  dispatch(retailAutomationActions.setAutomationSets(dataCopy));
};

export const backToProduct = (automationSets, dispatch) => {
  const dataCopy = JSON.parse(JSON.stringify(automationSets));
  let flag = false;
  for (let i = 0; i < dataCopy.length; i++) {
    if (dataCopy[i].selected) {
      for (let j = 0; j < dataCopy[i].setSteps.length; j++) {
        if (dataCopy[i].setSteps[j]?.active && dataCopy[i].setSteps[j]?.subLevels?.length) {
          dataCopy[i].setSteps[j].subLevels[1].selected = true;
          dataCopy[i].setSteps[j].subLevels[2].selected = false;
          flag = true;
          break;
        }
      }
      if (flag) break;
    }
  }
  const selectedSet = dataCopy.find((data) => data.selected);
  dispatch(retailAutomationActions.setAutomationSets(dataCopy));
  dispatch(retailAutomationActions.setSelectedSet(selectedSet));
};

export const artworkCompleted = async (automationSets, dispatch, proceedAhead = true) => {
  const dataCopy = JSON.parse(JSON.stringify(automationSets));
  let flag = false;
  for (let i = 0; i < dataCopy.length; i++) {
    if (dataCopy[i].selected) {
      for (let j = 0; j < dataCopy[i].setSteps.length; j++) {
        if (dataCopy[i].setSteps[j]?.active && dataCopy[i].setSteps[j]?.subLevels?.length) {
          if (proceedAhead) {
            dataCopy[i].setSteps[j].subLevels[2].selected = false;
            dataCopy[i].setSteps[j].subLevels[2].completed = true;
            dataCopy[i].setSteps[j].active = false;
            dataCopy[i].setSteps[j]['completed'] = true;
            dataCopy[i].setSteps[j + 1].active = true;
            dataCopy[i].setSteps[j + 1].subLevels[0].selected = true;
          } else {
            dataCopy[i].setSteps[j]['completed'] = true;
            dataCopy[i].setSteps[j].subLevels[2].completed = true;
          }
          flag = true;
          break;
        }
      }
      if (flag) break;
    }
  }
  const selectedSet = dataCopy.find((data) => data.selected);
  dispatch(retailAutomationActions.setAutomationSets(dataCopy));
  dispatch(retailAutomationActions.setSelectedSet(selectedSet));
};

export const sanitizeNameInRetailAutomation = (value, { maxLength, warningMessage = '' } = {}) => {
  if (!typeof value === 'string') value;
  const regex = new RegExp(NAME_EXCLUDED_SPECIAL_CHARS, 'g');
  value = value.replace(regex, '');
  if (value.length > maxLength) {
    value = value.substring(0, maxLength);
    if (warningMessage) warningToast(warningMessage);
  }
  return value;
};

export const createNewSetRedux = (createdSet, dispatch) => {
  if (createdSet?.data) {
    const copySets = JSON.parse(JSON.stringify(createdSet?.data));
    copySets['selected'] = true;
    copySets['showMenu'] = true;
    copySets['setSteps'] = initialSetSteps();
    if (copySets?.template) {
      copySets.setSteps[0].completed = true;
      copySets.setSteps[0].selected = false;
      copySets.setSteps[1].selected = true;
      copySets.setSteps[1].active = true;
    }
    dispatch(retailAutomationActions.setAutomationSets([copySets]));
    dispatch(retailAutomationActions.setSelectedSet(copySets));
  }
};

export const resetAllSetValues = (dispatch) => {
  dispatch(retailAutomationActions.setSelectedSet(null));
  dispatch(retailAutomationActions.setSelectedTemplate(null));
};

export const createHotspotList = async (list, roomHotspot) => {
  let copyList = JSON.parse(JSON.stringify(list));
  copyList = await Promise.all(
    copyList.map((val, ind) => {
      val['selected'] = true;
      val['thumbnail'] = '';
      // val['linked_product_blender_id'] =
      //   roomHotspot?.[ind]?.linked_product_blender_id ||
      //   roomHotspot?.[ind]?.linked_prop_object_name?.split('@')[1];
      val['linked_prop_object_id'] =
        roomHotspot?.[ind]?.linked_prop_object_id ||
        roomHotspot?.[ind]?.linked_prop_object_name.split('@')[1];
      val['linked_prop_object_name'] = roomHotspot?.[ind]?.linked_prop_object_name;
      val['cameraInfo'] = roomHotspot?.[ind]?.cameraInfo;
      return val;
    })
  );
  copyList.sort((a, b) => a.id - b.id);
  dispatcher(retailAutomationActions.setSelectedHotspots(copyList));
};

const updateLocalSetData = async (allHotspots) => {
  await wait(100);
  const automationSets = selectAutomationSets(getAppState());
  const dataCopy = JSON.parse(JSON.stringify(automationSets));
  if (dataCopy?.[0]?.setSteps?.[0]?.subLevels?.length) {
    for (let i = 0; i < dataCopy[0].setSteps[0].subLevels?.length; i++) {
      const currentHotspot = allHotspots?.find(
        (data) => data.id === dataCopy[0].setSteps[0].subLevels[i].id
      );
      if (currentHotspot?.json_file) {
        dataCopy[0].setSteps[0].subLevels[i].json_file = currentHotspot.json_file;
      }
    }
    dispatcher(retailAutomationActions.setAutomationSets(dataCopy));
  }
};

export const getAndCreateAutomationHotspots = async (setData, templates, getHotspotList) => {
  const automationId = selectRetailAutomationId(getAppState());
  let allHotspots = await getHotspotList({
    retailAutomationId: automationId,
    retailSetId: setData?.id,
  });
  allHotspots?.sort((a, b) => a.id - b.id);
  const selectedTemplateInfo = templates.find((data) => data.id === setData?.template);
  const roomJson = await getJson(selectedTemplateInfo?.room_file);
  if (!allHotspots?.length) {
    if (selectedTemplateInfo?.room_file) {
      let selectedValue = false;
      if (allHotspots?.length === 0) {
        selectedValue = true;
      }
      let allHotspotsFromJson = roomJson?.hotspot?.map((data, index) => {
        data['name'] = 'In-Store Location ' + (index + 1);
        data['selected'] = selectedValue;
        data['id'] = index + 1;
        data['fromRoomJson'] = true;
        return data;
      });
      if (allHotspotsFromJson?.length) {
        await createHotspotList(allHotspotsFromJson, roomJson?.hotspot);
      }
    }
  } else {
    await createHotspotList(allHotspots, roomJson?.hotspot);
  }
  updateLocalSetData(allHotspots);
  return allHotspots;
};

export const emptyRowData = (defaultData) => {
  const artworkEmptyRow = {
    item: defaultData?.item?.map((data, index) => ({
      variationObjectId: +data.variationObjectId,
      variationObjectName: data.variationObjectName,
      materialName: data.materialName,
      id: index + 1,
      upload: true,
    })),
  };
  // const artworkEmptyRow = defaultArray?.map((data, index) => ({
  //   id: data.id,
  //   variationObjectId: +data.variationObjectId,
  //   variationObjectName: data.variationObjectName,
  //   materialName: data.materialName,
  //   item: [{ id: index + 1, upload: true}],
  // }));
  return artworkEmptyRow;
};

// export const createACombination = async (payload) => {
//   let newPayload = {};

//   if (payload?.json_file) {
//     const { json_file, ...restPayload } = payload;
//     newPayload = {
//       ...restPayload,
//       json_file: 'json_file.json',
//     };
//   } else {
//     newPayload = payload;
//   }

//   const newData = await apiCreateArtworkCombination(newPayload);

//   if (payload?.json_file && newData?.data?.presigned_data_json_file) {
//     apiPostImageOnPresignedData(payload?.json_file, newData?.data?.presigned_data_json_file);
//   }

//   return newData?.data;
// };

// export const createDefaultCombination = async (payload, roomJsonBlob) => {
//   let payloadToPass = JSON.parse(JSON.stringify(payload));
//   payload['name'] = '1';
//   payloadToPass['json_file'] = 'json_file.json'; // roomJsonBlob;
//   payloadToPass['is_default'] = true;
//   const newData = await apiCreateArtworkCombination(payloadToPass);

//   if (roomJsonBlob && newData?.data?.presigned_data_json_file) {
//     apiPostImageOnPresignedData(roomJsonBlob, newData?.data?.presigned_data_json_file);
//   }

//   return newData?.data;
// };

export const shouldUpdateAutomationSetsData = (newSets = []) => {
  if (!Array.isArray(newSets) || newSets?.length === 0) return false;

  const existingSets = selectAutomationSets(getAppState());
  return !isEqual(existingSets, newSets);
};

export const updateSetJson = async (dataJson = [], _payload = {}) => {
  if (!dataJson.length) return null;

  const selectedSet = dataJson.find((set) => set.selected);

  const payload = {
    json_data: JSON.stringify(dataJson),
    id: selectedSet?.id,
    ..._payload,
  };

  return dispatcher(updateRetailAutomationSets(payload));
};

// export const updateSetJson = async (dataJson, _payload = {}) => {
//   const selectedSet = dataJson.find((set) => set.selected);
//   const payload = {
//     ...(dataJson && {
//       json_data: JSON.stringify(dataJson),
//       id: selectedSet?.id,
//     }),
//     ..._payload
//   };
//   const newSetData = await dispatcher(updateRetailAutomationSets(payload));
//   return newSetData;
// };
export const createANewCollection = async (name, id) => {
  let payload = {
    name: name,
    description: name + '_description',
    owner: id,
  };
  const collectionInfo = await createCollectionApi(payload);
  return collectionInfo?.data;
};

const mergeProps = (sceneJson, mergedJsonValue) => {
  let copyJSON = JSON.parse(JSON.stringify(mergedJsonValue));
  const sceneProps = sceneJson?.blenderAssetBundleDatas?.map((_item) => _item?.objectName);
  const roomProps = copyJSON?.blenderAssetBundleDatas?.filter(
    (_item) => !sceneProps?.includes(_item?.objectName)
  );
  const { activeLinkedPropObjectName } = selectActiveSetDetails(getAppState());
  roomProps?.forEach((_item) => {
    if (_item.objectName === activeLinkedPropObjectName) {
      _item.isRetailProp = true;
    }
  });
  // const _sceneProps = sceneJson?.blenderAssetBundleDatas?.map((_item) => {
  //   const propInRoom = copyJSON?.blenderAssetBundleDatas?.find(
  //     (item) => item?.objectName === _item?.objectName
  //   );
  //   return propInRoom
  //     ? {
  //         ..._item,
  //         childrenMaterials: _item?.childrenMaterials?.map((item) => ({
  //           ...item,
  //           originalMaterialName: propInRoom?.childrenMaterials?.find(
  //             (__item) => __item?.childName === item?.childName
  //           )?.materialName,
  //         })),
  //       }
  //     : _item;
  // });

  let newArr = [...roomProps, ...(sceneJson?.blenderAssetBundleDatas || [])];

  return newArr;
};

const checkToAddObj = (str, sceneJson, mergedJsonValue) => {
  const copyJSON = JSON.parse(JSON.stringify(mergedJsonValue));
  if (sceneJson[str]) {
    const allKeys = Object.keys(sceneJson[str]);
    let linkedObjectTransform;
    if (str === 'transformChangedObjectData') {
      const propDataFromUnity = selectPropDataReceivedFromUnity(getAppState());

      for (let i = 0; i < allKeys?.length; i++) {
        const isDataInPropData = propDataFromUnity?.find((val) => val.objectName === allKeys[i]);

        const { activeLinkedPropObjectName } = selectActiveSetDetails(getAppState());
        if (isDataInPropData?.objectName) {
          linkedObjectTransform = copyJSON[str][activeLinkedPropObjectName];
          break;
        }
      }
      if (linkedObjectTransform) {
        copyJSON[str]['linkedObjectTransform'] = linkedObjectTransform;
      }
      for (let i = 0; i < allKeys?.length; i++) {
        copyJSON[str] = { ...copyJSON[str], ...sceneJson[str] };
        if (copyJSON[str][allKeys[i]] && sceneJson[str][allKeys[i]]) {
          copyJSON[str][allKeys[i]] = sceneJson[str][allKeys[i]];
        }
      }
    } else {
      for (let i = 0; i < allKeys?.length; i++) {
        if (!copyJSON[str][allKeys[i]]) {
          copyJSON[str][allKeys[i]] = sceneJson[str][allKeys[i]];
        }
      }
    }
  }
  return copyJSON[str];
};

const getGroupPropMap = (sceneJson, templateJson) => {
  const obj = sceneJson?.groupPropsMapping;
  const selectedProduct = selectCurrentSelectedProduct(getAppState());
  const matchedCurrentProp = Object.keys(sceneJson?.retailAutomationChildPropList).find((data) =>
    data.includes(selectedProduct?.product)
  );
  if (matchedCurrentProp) {
    let allObjects = sceneJson['retailAutomationChildPropList'][matchedCurrentProp];
    allObjects.push(matchedCurrentProp);
    const splittedValue = matchedCurrentProp?.split('@');
    const propId = splittedValue[1];
    const indexValue = splittedValue[0];
    if (propId && indexValue) {
      const newGroupData = {};
      const groupPropId = !matchedCurrentProp?.toString()?.includes('groupProp')
        ? `${matchedCurrentProp}_groupProp`
        : matchedCurrentProp?.toString();
      newGroupData[groupPropId] = {
        objectNames: allObjects,
        groupId: propId,
        groupName: selectedProduct?.name || '',
        groupObjectName: groupPropId,
        transformChangedObjectData: !matchedCurrentProp?.toString()?.includes('groupProp')
          ? templateJson['transformChangedObjectData'][matchedCurrentProp]
          : {},
      };
      // TODO check this if condition after rendering in case of group prop creation in RA
      if (
        !matchedCurrentProp?.toString()?.includes('groupProp') &&
        newGroupData[groupPropId]['transformChangedObjectData']
      ) {
        newGroupData[groupPropId]['transformChangedObjectData']['objectName'] = groupPropId;
      }
      obj[propId] = {
        groupData: newGroupData,
        currentIndex: indexValue,
        objectCount: 1,
        groupId: propId,
        groupName: selectedProduct?.name || '',
        type: 'RetailAutomationReplaceProp',
      };
    }
  }
  return obj;
};

export const mergeJson = async (templateId) => {
  const allTemplates = selectAllTemplates(getAppState());
  const selectedTemplate = allTemplates?.find((val) => val.id === templateId);
  let jsonValue;
  let mergedJsonValue;
  let sceneJson;
  if (selectedTemplate?.room_file) {
    jsonValue = await getJson(selectedTemplate?.room_file);
    mergedJsonValue = JSON.parse(JSON.stringify(jsonValue));
    sceneJson = await waitForEventOnce(UnityEvent.GetRoomInfo, () =>
      window.roomModule.GetRedBullProjectJson()
    );
    mergedJsonValue['materialDetails'] = [
      ...(sceneJson?.materialDetails || []),
      ...mergedJsonValue['materialDetails'],
    ];
    mergedJsonValue['blenderAssetBundleDatas'] = mergeProps(sceneJson, mergedJsonValue);
    mergedJsonValue['deletedObjectData'] = [
      ...(sceneJson?.deletedObjectData || []),
      ...mergedJsonValue['deletedObjectData'],
    ];
    mergedJsonValue['propsHierarchyData'] = checkToAddObj(
      'propsHierarchyData',
      sceneJson,
      mergedJsonValue
    );
    mergedJsonValue['transformChangedObjectData'] = checkToAddObj(
      'transformChangedObjectData',
      sceneJson,
      mergedJsonValue
    );
    let linkedValueToAdd;
    const linkedObjectTransformValue =
      mergedJsonValue['transformChangedObjectData']['linkedObjectTransform'];
    if (linkedObjectTransformValue) {
      linkedValueToAdd = JSON.parse(JSON.stringify(linkedObjectTransformValue));
      delete mergedJsonValue['transformChangedObjectData']['linkedObjectTransform'];
    }
    mergedJsonValue['linkedObjectTransformValue'] = linkedValueToAdd;
    mergedJsonValue['retailAutomationChildPropList'] = sceneJson['retailAutomationChildPropList'];
    mergedJsonValue['groupPropsMapping'] = getGroupPropMap(sceneJson, mergedJsonValue);
    if (mergedJsonValue?.materialDetails?.length) {
      const materialDetails = JSON.parse(JSON.stringify(mergedJsonValue.materialDetails));
      const values = [
        ...Object.values(CHANGED_MAP_PATHS__TEXTURE_MAP),
        'loadedMaterialPath',
        'materialTexturePath',
      ];
      const updatedMaterialDetails = materialDetails.map((material) => {
        values.map((path) => {
          if (material?.[path]?.includes('blob')) {
            material[path] = '';
          }
        });
        return material;
      });
      mergedJsonValue.materialDetails = updatedMaterialDetails;
    }
  }
  delete mergedJsonValue['cameraList'];
  delete mergedJsonValue['hotspot'];
  // console.log(jsonValue, sceneJson, 'check json values', mergedJsonValue);
  return mergedJsonValue;
};

export const blobUrlToFile = async (blobUrl, fileName) => {
  // Fetch the blob data from the URL
  const response = await fetch(blobUrl);
  const blob = await response.blob();

  // Create a new File from the Blob
  const file = new File([blob], fileName, { type: blob.type });
  return file;
};

export const blobUrlToThumbnailFile = async (blobUrl, fileName) => {
  // Fetch the blob data
  const response = await fetch(blobUrl);
  const blob = await response.blob();

  // Create an image from the blob
  const img = await new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = URL.createObjectURL(blob);
  });

  // Calculate new size while maintaining aspect ratio
  const maxDim = 200;
  let { width, height } = img;
  if (width > height) {
    if (width > maxDim) {
      height = Math.round((height * maxDim) / width);
      width = maxDim;
    }
  } else {
    if (height > maxDim) {
      width = Math.round((width * maxDim) / height);
      height = maxDim;
    }
  }

  // Draw resized image on a canvas
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, width, height);

  // Convert canvas back to blob
  const resizedBlob = await new Promise(
    (resolve) => canvas.toBlob(resolve, blob.type, 0.75) // 0.75 = quality for JPEG/WebP
  );

  // Create file from resized blob
  return new File([resizedBlob], fileName, { type: blob.type });
};

export const blobUrlToFileWithThumbnail = async (blobUrl, fileName) => {
  // Fetch the blob data
  const response = await fetch(blobUrl);
  const blob = await response.blob();

  // Create original file
  const originalFile = new File([blob], fileName, { type: blob.type });

  // Create an image from the blob
  const img = await new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = URL.createObjectURL(blob);
  });

  // Calculate new size while maintaining aspect ratio
  const maxDim = 200;
  let { width, height } = img;
  if (width > height) {
    if (width > maxDim) {
      height = Math.round((height * maxDim) / width);
      width = maxDim;
    }
  } else {
    if (height > maxDim) {
      width = Math.round((width * maxDim) / height);
      height = maxDim;
    }
  }

  // Draw resized image on a canvas
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, width, height);

  // Convert canvas back to blob
  const resizedBlob = await new Promise(
    (resolve) => canvas.toBlob(resolve, blob.type, 0.75) // 0.75 = quality for JPEG/WebP
  );

  // Create thumbnail file
  const thumbnailFile = new File([resizedBlob], `thumb_${fileName}`, { type: blob.type });

  // Return both files
  return {
    originalFile,
    thumbnailFile,
  };
};

export const saveDefaultTexturesInDb = async (payloadPassed, ind, createArtworkTexture) => {
  const { localData, thumbnailData, payload, id } = payloadPassed;
  const payloadToSend = {
    retail_set: payload['retail_set'],
    hotspot: payload['retail_hotspot'],
  };

  payloadToSend['texture_data'] = await Promise.all(
    localData?.map((data, index) => {
      const payloadLocal = {
        color_code: data?.extraData?.isColor ? data?.extraData?.colorValue : '',
        name: data?.materialName,
        is_default: true,
        artwork: id,
        material_properties: data,
        json_data: {},
        extra_data: {},
        texture_type: data?.extraData?.isColor
          ? OPTION_TYPE.COLOR
          : data?.extraData?.isTexture
          ? OPTION_TYPE.TEXTURE
          : OPTION_TYPE.MATERIAL,
        seq_no: index + ind,
      };
      if (!data?.extraData?.isColor) {
        let ext = data?.extra_data?.textureFormat || '.png';
        if (!ext?.includes('.')) {
          ext = `.${ext}`;
        }
        payloadLocal['thumb'] = data?.materialName?.trim() + ext;
        payloadLocal['texture_file'] = data?.materialName?.trim() + ext;
      }
      return payloadLocal;
    })
  );
  const savedData = await createArtworkTexture({ payload: payloadToSend });
  if (savedData?.data?.length) {
    const allData = JSON.parse(JSON.stringify(savedData?.data));
    const copyThumbnail = JSON.parse(JSON.stringify(thumbnailData));
    allData?.sort((a, b) => a.name - b.name);
    copyThumbnail.sort((a, b) => a.id - b.id);
    allData.map(async (a, i) => {
      if (thumbnailData?.[i]?.thumbnail) {
        let extension = thumbnailData?.[i]?.extra_data?.textureFormat || '.png';
        if (!extension?.includes('.')) {
          extension = `.${extension}`;
        }

        // const [fileThumb, fileMainFile] = await Promise.all([
        //     blobUrlToThumbnailFile(
        //     thumbnailData?.[i]?.thumbnail,
        //     `${a.name}${extension}`
        //   ),
        //   blobUrlToFile(
        //     thumbnailData?.[i]?.texture_file || thumbnailData?.[i]?.thumbnail,
        //     `${a.name}${extension}`
        //   )
        // ]);

        const { thumbnailFile: fileThumb, originalFile: fileMainFile } =
          await blobUrlToFileWithThumbnail(
            thumbnailData?.[i]?.texture_file || thumbnailData?.[i]?.thumbnail,
            `${a.name}${extension}`
          );

        if (fileMainFile) apiPostImageOnPresignedData(fileMainFile, a.presigned_data_texture_file);
        await apiPostImageOnPresignedData(fileThumb, a.presigned_data_thumb);
      }
    });
    return savedData?.data;
  }
  return [];
};

export const loadRetailHotspotRoom = async ({ roomJson, hotspotData, roomModule }) => {
  // clearCacheFromAPI();
  // const callOnlyOnce = selectCalledOnce(getAppState());
  // dispatcher(configuratorActions.setUnitySceneLoaded(false));
  // if (callOnlyOnce) {
  //   configuratorModule.ResetConfiguratorReceiver();
  //   await waitForEventOnce(CONFIGURATOR_UNITY_EVENT.OnConfiguratorSceneLoaded);
  // }
  let blenderAssetBundleDatas = roomJson?.blenderAssetBundleDatas;
  let transformChangedObjectData = roomJson?.transformChangedObjectData;
  if (hotspotData) {
    const objectName = hotspotData?.linked_prop_object_name;
    blenderAssetBundleDatas = roomJson?.blenderAssetBundleDatas?.filter(
      (val) => val.objectName === objectName
    );
    transformChangedObjectData = {};
    Object.keys(roomJson?.transformChangedObjectData || {}).forEach((key) => {
      if (key.includes(objectName)) {
        transformChangedObjectData[key] = roomJson?.transformChangedObjectData[key];
      }
    });
  }
  const propsData = await getInitialUnityProps({
    blenderAssetBundleDatas,
    transformChangedObjectData,
  });
  const { unityProps, allProps } = propsData;
  // const config = {
  //   roomCameraInfo: retailAutomationDefaultCamera,
  //   deletedObjectsData: !hotspotData
  //     ? roomJson?.deletedObjectData || roomJson?.deletedObjectsData || []
  //     : [],
  //   retailAutomationReplacePropList: roomJson?.retailAutomationReplacePropList || {},
  //   transformData: !hotspotData ? roomJson.transformChangedObjectData || {} : {},
  //   props: unityProps,
  //   isRetailAutomation: true,
  //   hotSpotDatas: roomHotspotData,
  // };
  // const productIds = unityProps.map((prop) => parseInt(prop.id));
  // setSessionStorage('instantiatedProps', JSON.stringify(productIds));
  // configuratorModule.CreateConfiguratorReceiver(config);
  await loadUnityProps({
    unityPropList: unityProps,
    initProp: roomModule.InstantiatePropReceiever,
    unityLoadedSelector: selectUnityLoaded,
    fetchProps: (ids) => createPropsLoader(ids, allProps),
  });
};

const createPropsLoader = async (propIds, loadedProps) => {
  if (isEmpty(propIds)) {
    return {
      results: [],
    };
  }
  const propIdList = propIds;
  let props = [];
  const uniqPropIdList = uniq(propIdList);
  const propsObj = {};
  await Promise.all(
    uniqPropIdList.map(async (productId) => {
      // const result = await fetchAllPages((page) => propsReadApi([productId], page));
      // TODO: handle prop loading failed
      // propsObj[productId] = result?.results || [];
      const result = JSON.parse(JSON.stringify(loadedProps));
      propsObj[productId] = result?.length ? result : [];
    })
  );
  propIdList.map((val) => {
    if (propsObj?.[val]) {
      props = props.concat(propsObj?.[val]);
    }
  });

  props = removeDuplicatesByKey(props, 'id');

  if (!props?.length) {
    errorToastV2('Product is not present');
  }
  return {
    results: props,
  };
};

const getInitialUnityProps = async ({ blenderAssetBundleDatas, transformChangedObjectData }) => {
  // Step 1: Generate Unity Prop List with transform data
  const allIds = [];
  const unityPropList = blenderAssetBundleDatas?.reduce((acc, asset) => {
    const transform = transformChangedObjectData?.[asset?.objectName];
    if (transform) {
      allIds.push(asset.id);
      acc.push({
        type: 'ProjectProp',
        isRetailAutomationProp: true,
        id: asset.id,
        objectName: asset.objectName,
        indexName: asset.objectIndex,
        isRoofProp: asset?.is_roof_prop,
        xPosition: transform.xPosition,
        yPosition: transform.yPosition,
        zPosition: transform.zPosition,
        xRotation: transform.xRotation,
        yRotation: transform.yRotation,
        zRotation: transform.zRotation,
        wRotation: transform.wRotation,
        xScale: transform.xScale,
        yScale: transform.yScale,
        zScale: transform.zScale,
        propLoaderId: uuidv4(),
        childrenMaterials: asset?.childrenMaterials || [],
      });
    }
    return acc;
  }, []);

  // Step 2: fetch
  const { productVariantData, allProps } = await getVariantsForArtworkJsonForProductVariant(allIds);

  // Step 3: Attach isProductVariant flag to each unity prop
  let enrichedUnityProps = unityPropList
    ?.map((prop) => {
      const match = productVariantData?.find((item) => item.id === prop.id);
      if (match) {
        prop.isProductVariant = match.isProductVariant;
      }
      return prop;
    })
    .filter(Boolean);

  // here, keeping product variants ( it can be rack/save template rack ) in the front always
  enrichedUnityProps = [
    ...enrichedUnityProps.filter((prop) => prop.isProductVariant),
    ...enrichedUnityProps.filter((prop) => !prop.isProductVariant),
  ];

  return {
    unityProps: enrichedUnityProps,
    allProps,
  };
};

// Commented as we are no more using this
// export const getActiveHotspot = () => {
//   const automationSets = selectAutomationSets(getAppState());
//   const selectedSet = automationSets.find((data) => data.selected);
//   const activeHotspot = selectedSet?.setSteps?.[0]?.subLevels.find(
//     (data) => data.active && data.is_enable
//   );
//   return activeHotspot;
// };

export const getHotspotFromId = (hotspotId) => {
  const automationSets = selectAutomationSets(getAppState());
  const selectedSet = automationSets.find((data) => data.selected);
  const hotspot = selectedSet?.setSteps?.[0]?.subLevels.find(
    (data) => parseInt(data.id) === parseInt(hotspotId)
  );
  return hotspot;
};

export const updateArtworkSet = async ({ data, isUpdate = true }) => {
  let result = null;
  const { json_file_content } = data;
  if (json_file_content) {
    const jsonBlob = new Blob([JSON.stringify(json_file_content)], {
      type: 'application/json',
    });
    delete data?.json_file_content;
    data.json_file = jsonBlob;
  }
  if (isUpdate) {
    result = await updateHotspotJsonApiV2({ data });
    // result = await dispatcher(updateHotspotApi(payload));
  }
  const automationSets = selectAutomationSets(getAppState());
  const currentSetTemplateId = selectTemplateId(getAppState());
  const dataCopy = JSON.parse(JSON.stringify(automationSets));
  const allLevels = dataCopy?.[0]?.setSteps?.[0]?.subLevels;
  for (let i = 0; i < allLevels?.length; i++) {
    if (allLevels[i].id === data?.id) {
      const data = { ...allLevels[i], ...(result?.data?.id ? result?.data : data) };
      allLevels[i] = data;
    }
  }
  dispatcher(retailAutomationActions.setAutomationSets(dataCopy));
};

export const getVariantProductsListFromDb = async ({ productIds }) => {
  const propIdList = productIds;
  let props = [];

  if (propIdList.length === 0) return props;

  const uniqPropIdList = uniq(propIdList);
  const propsObj = {};
  await Promise.all(
    uniqPropIdList.map(async (productId) => {
      const result = await fetchAllPages((page) => propsReadApi([productId], page));
      // TODO: handle prop loading failed
      propsObj[productId] = result?.results || [];
      // props = props.concat(result?.results || []);
    })
  );
  propIdList.map((val) => {
    if (propsObj?.[val]) {
      props = props.concat(propsObj?.[val]);
    }
  });
  return props;
};

export const getPropCount = async (productId) => {
  const { activeLinkedPropObjectId, activeLinkedPropObjectName } = selectActiveSetDetails(getAppState())
  
  if (activeLinkedPropObjectId) {
    if (parseInt(activeLinkedPropObjectId) === parseInt(productId)) {
      const ids = activeLinkedPropObjectName?.split('@');
      return parseInt(ids[0]) - 1;
    }
    const roomJson = await waitForEventOnce(UnityEvent.GetRoomInfo, () =>
      window.roomModule.GetRedBullProjectJson()
    );
    const count = roomJson?.blenderAssetBundleDatas?.filter(
      (val) => parseInt(val.id) === parseInt(productId)
    )?.length;
    return count;
  }
  return 0;
};

// TODO: remove this function once unity sends all deleted props in one list
// Unity should send all deleted props in one list
// Currently props come one by one, causing multiple API calls
// To prevent duplicate API calls, we store deleted props in localStorage
// When same prop ID comes again, we update the list without making API call
export const setAndGetDeletedPropList = async (list = []) => {
  return new Promise((resolve) => {
    const currentList = getSessionStorage(RETAIL_AUTOMATION_DELETED_PROPS_LIST, true) || [];
    const updatedList = list.reduce((acc, item) => {
      if (currentList.includes(item)) {
        return acc.filter((x) => x !== item);
      }
      return [...acc, item];
    }, currentList);

    setSessionStorage(RETAIL_AUTOMATION_DELETED_PROPS_LIST, updatedList);
    resolve(updatedList);
  });
};

export const updateLocalStorageData = (texData) => {
  if (sessionStorage?.getItem(RETAIL_AUTOMATION_DELETED_PROPS_LIST)) {
    let localData = JSON.parse(sessionStorage?.getItem(RETAIL_AUTOMATION_DELETED_PROPS_LIST));
    if (typeof localData === 'string') {
      localData = parseInt(localData);
    }
    let result = localData?.filter((data) => !texData.includes(data));
    if (!result?.length) {
      sessionStorage.removeItem(RETAIL_AUTOMATION_DELETED_PROPS_LIST);
    } else {
      setSessionStorage(RETAIL_AUTOMATION_DELETED_PROPS_LIST, result);
    }
  }
};

// export const removeTexturesFromArtwork = async (propsPassed, deleteArtworkTexture) => {
//   const {
//     notSelectedProdIds,
//     defaultArtworks,
//     finalArtworks,
//     selectedSet,
//     callback,
//     notSelectedProdSeqNo,
//     calledFrom,
//   } = propsPassed;
//   if (notSelectedProdIds?.length) {
//     let defaultArtworkIds = [];
//     let finalArtworksIds = [];
//     let finalTexturesToDelete = [];
//     let finalTexturesToDeleteForRack = [];
//     let copyDefault;

//     // TODO: Remove/Refactor the working to delete all the items except 0 index
//     if (selectIsClearRackTriggered(getAppState())) {
//       const defaultIds =
//         defaultArtworks.item?.slice(1).map((a) => a?.dbId || a?._dbId || a?.id) || [];

//       const finalIds =
//         finalArtworks?.flatMap((a) =>
//           a.item
//             .slice(1)
//             .filter((b) => b.artwork || (!b.defaultAdded && !b.upload)) // artwork key is here to check if texture is coming from backend
//             .map((b) => b.id)
//         ) || [];

//       finalTexturesToDeleteForRack = [...defaultIds, ...finalIds];
//     }

//     if (defaultArtworks?.item?.length) {
//       const matchedData = defaultArtworks?.item
//         ?.filter((data) => notSelectedProdIds.includes(data.id))
//         .map((data) => data.dbId || data?._dbId);
//       copyDefault = JSON.parse(JSON.stringify(defaultArtworks));
//       copyDefault['item'] = copyDefault['item'].filter(
//         (data) => !notSelectedProdIds.includes(data.id)
//       );

//       // commented code as we don't need to update the remaining texture sequence number
//       // for (let i = 0; i < copyDefault?.item?.length; i++) {
//       //   if (copyDefault.item[i].seq_no > notSelectedProdSeqNo) {
//       //     copyDefault.item[i].seq_no--;
//       //   }
//       // }
//       if (matchedData?.length) {
//         defaultArtworkIds.push(...matchedData);
//       }
//     }
//     if (notSelectedProdIds?.length) {
//       const defaultArtworksLocal = defaultArtworks; // selectArtworkDefaultCombinations(getAppState());

//       // resetting the default artwork
//       // In case of clear rack -> expect the first index data. Deleting all the data.
//       // In case of clear tray -> deleting the selected selected ids.
//       const filteredDefaultArtwork = selectIsClearRackTriggered(getAppState())
//         ? defaultArtworksLocal?.item?.filter(
//             (data) => !finalTexturesToDeleteForRack.includes(data?.dbId || data?._dbId || data.id)
//           )
//         : defaultArtworksLocal?.item?.filter((data) => !notSelectedProdIds.includes(data.id));

//       dispatcher(
//         retailAutomationActions.updateOnlyDefaultArtwork({ item: filteredDefaultArtwork })
//       );
//     }
//     if (finalArtworks?.length) {
//       for (let j = 0; j < finalArtworks?.length; j++) {
//         const matchedData = finalArtworks[j]?.item
//           ?.filter(
//             (data, ind) =>
//               notSelectedProdIds.includes(data.defaultObjData?.id) &&
//               (data.artwork || (!data.defaultAdded && !data.upload))
//           )
//           .map((data) => data.id);
//         if (matchedData?.length) {
//           finalArtworksIds.push(...matchedData);
//         }
//       }
//     }
//     // for (let i = 0; i < notSelectedProdIds?.length; i++) {
//     //   if (defaultArtworks?.item?.length) {
//     //     const matchedData = defaultArtworks?.item
//     //       ?.filter((data, ind) => data.id === notSelectedProdIds[i])
//     //       .map((data) => data.dbId);
//     //     copyDefault = JSON.parse(JSON.stringify(defaultArtworks));
//     //     copyDefault['item'] = copyDefault['item'].filter(
//     //       (data, ind) => data.id !== notSelectedProdIds[i]
//     //     );

//     //     if (matchedData?.length) {
//     //       defaultArtworkIds.push(...matchedData);
//     //     }
//     //   }
//     //   if (finalArtworks?.length) {
//     //     for (let j = 0; j < finalArtworks?.length; j++) {
//     //       const matchedData = finalArtworks[j]?.item
//     //         ?.filter(
//     //           (data, ind) =>
//     //             data.defaultObjData?.id === notSelectedProdIds[i] &&
//     //             !data.defaultAdded &&
//     //             !data.upload
//     //         )
//     //         .map((data) => data.id);
//     //       if (matchedData?.length) {
//     //         finalArtworksIds.push(...matchedData);
//     //       }
//     //     }
//     //   }
//     // }
//     if (selectIsClearRackTriggered(getAppState())) {
//       finalTexturesToDelete = finalTexturesToDeleteForRack;
//     } else {
//       finalTexturesToDelete = [...defaultArtworkIds, ...finalArtworksIds].filter(Boolean);

//       if (calledFrom === 'afterReplace') {
//         finalTexturesToDelete = await setAndGetDeletedPropList(finalTexturesToDelete);
//       }
//     }

//     if (finalTexturesToDelete?.length) {
//       const payload = {
//         textureIds: finalTexturesToDelete
//       };
//       dispatcher(retailAutomationActions.setCombinationSectionLoader(true));
//       const deleteTextures = await deleteArtworkTexture({payload, id: finalTexturesToDelete[0]});
//       if (calledFrom === 'afterReplace') {
//         updateLocalStorageData(finalTexturesToDelete);
//       }
//       if (getSessionStorage(RETAIL_AUTOMATION_DELETED_PROPS_LIST))
//         setTimeout(() => removeSessionStorage(RETAIL_AUTOMATION_DELETED_PROPS_LIST), 3000);
//       if (deleteTextures?.status) {
//         callback?.();
//         return copyDefault;
//       }
//     } else {
//       return copyDefault;
//       // errorToastV2('No textures to delete');
//     }
//     return null;
//   }
// };

export const urlToBlobUrl = async (url) => {
  // Fetch the data from the URL
  try {
    const response = await fetch(url);

    // Ensure the response is successful
    if (!response.ok) {
      throw new Error('Something went wrong on download texture.');
    }

    // Get the response as a Blob
    const blob = await response.blob();

    // Create a Blob URL from the Blob
    const blobUrl = URL.createObjectURL(blob);

    return blobUrl;
  } catch (e) {
    console.log(e, 'error here');
  }
  return '';
};

export const urlToBlob = async (url) => {
  // Fetch the data from the URL
  try {
    const response = await fetch(url);

    // Ensure the response is successful
    if (!response.ok) {
      throw new Error('Something went wrong on download texture.');
    }

    // Get the response as a Blob
    const blob = await response.blob();
    return blob;
  } catch (e) {
    console.log(e, 'error here');
  }
  return null;
};

export const clearObjectValues = (obj) => {
  if (obj) {
    Object.keys(obj).forEach((key) => {
      obj[key] = ''; // Set each key's value to an empty string
    });
  }
  return obj;
};

export const updateMaterialObjectForDefault = async (artwork) => {
  const obj = await updateMaterialObjectForCombination(artwork?.extraData);
  return obj;
};

export const updateMaterialObjectForCombination = async (dataObject) => {
  const data = cloneDeep(dataObject);
  await updateMissingTexturesInDb({ materialProperies: data });
  const storedDefaultTextures = selectDefaultTextureData(getAppState());
  const defaultTextures = window.defaultTexures;
  Object.keys(defaultTextures).forEach((key) => {
    const defaultTexture = defaultTextures[key];
    // Don't know why updating again and again if default textures stored
    if (defaultTexture?.imageUrl) return;
    const texture = storedDefaultTextures?.[defaultTexture?.textureName];
    if (texture && texture?.thumbnail) {
      defaultTextures[key].imageUrl = texture.thumbnail;
    }
  });
  const objectWithDefaultTextures = await addDefaultTexturesToObject(data);
  return objectWithDefaultTextures;
};

export const clearAllMaterialDetailsKey = async (objPassed) => {
  const { allMatData, resetBooleanKey, resetColorKey } = objPassed;
  if (allMatData?.length) {
    let copyMatData = JSON.parse(JSON.stringify(allMatData));
    await Promise.all(
      copyMatData?.map((matDetail) => {
        const keys = [
          'AO',
          'diffuse',
          'metallic',
          'normal',
          'roughness',
          'transparency',
          'loadedMaterial',
          'material',
        ];
        for (let j = 0; j < keys.length; j++) {
          matDetail[keys[j] + 'Id'] = '';
          matDetail[keys[j] + 'Path'] = null;
        }
        if (resetBooleanKey) {
          matDetail['isTextureChanged'] = false;
          matDetail['isMaterialChanged'] = false;
          matDetail['isColor'] = false;
        }
        if (resetColorKey) {
          matDetail['color'] = '1|1|1';
          matDetail['colorBlender'] = '1|1|1';
        }
        return matDetail;
      })
    );
    return copyMatData;
  }
  return [];
};

// export const updateArtworkRenderJson = async (objectRecieved, callback = null) => {
//   const cardIndexClicked = selectCardIndexClicked(getAppState());
//   const { allCombinations, activeTemplateId, defaultArtworks, selectedVariationId, dispatch } =
//     objectRecieved;
//   // let allCombinationCopy = JSON.parse(JSON.stringify(allCombinations));
//   // allCombinationCopy = allCombinationCopy?.filter((data) => data.product === selectedVariationId);
//   for (let i = 0; i < allCombinations?.length; i++) {
//     if (allCombinations[i].json_file) {
//       let roomJson = await mergeJson(activeTemplateId);
//       let defaultCopy = JSON.parse(JSON.stringify(defaultArtworks));
//       let allUniqueVariations = defaultCopy?.item?.filter(
//         (thing, index, self) =>
//           self.findIndex((t) => t.variationObjectName === thing.variationObjectName) === index
//       );
//       const selectedVariationObjectName = selectSelectedVariationProd(getAppState());
//       allUniqueVariations = allUniqueVariations?.map((data) => data.variationObjectName);
//       roomJson.variants = [];
//       // roomJson.variants = allUniqueVariations;
//       // roomJson.variants = await getVariantsForArtworkJson(roomJson.variants);
//       const variant_prop_name =
//         allUniqueVariations?.find((_item) => _item.includes(selectedVariationObjectName)) ||
//         `${selectedVariationObjectName}`;
//       roomJson.current_linked_prop_object_name = variant_prop_name;

//       if (
//         (cardIndexClicked &&
//           (cardIndexClicked?.row === 'isDefault' || cardIndexClicked?.row === 'default') &&
//           !allCombinations[i].is_default) ||
//         (cardIndexClicked?.row != 'isDefault' &&
//           cardIndexClicked?.row != 'default' &&
//           cardIndexClicked?.row !== allCombinations[i]?.id)
//       ) {
//         let artworkJson = await getJson(allCombinations[i].json_file);
//         const allMatNames =
//           artworkJson.materialDetails.map((data) => data.matName)?.filter((data) => data) || [];
//         const uniqueMaterials =
//           roomJson?.materialDetails?.filter((data) => !allMatNames?.includes(data.matName)) || [];
//         artworkJson.materialDetails.forEach((data) => {
//           const foundedMatObj = roomJson?.materialDetails?.find(
//             (jsonVal) => jsonVal.matName === data.matName
//           );
//           if (foundedMatObj?.matName) {
//             data['copiedFromObjectName'] = foundedMatObj.copiedFromObjectName;
//           }
//         });
//         artworkJson['blenderAssetBundleDatas'] = roomJson['blenderAssetBundleDatas'];
//         artworkJson.materialDetails = [...artworkJson.materialDetails, ...uniqueMaterials];
//         // merge case if condition
//         if (roomJson.materialDetails.length < artworkJson.materialDetails.length) {
//           const allRoomJsonMatName = roomJson.materialDetails.map((data) => data.matName);
//           artworkJson.materialDetails = artworkJson.materialDetails.filter((data) =>
//             allRoomJsonMatName.includes(data.matName)
//           );
//         }
//         if (allCombinations[i].is_default) {
//           const dataToPass = {
//             allMatData: artworkJson.materialDetails,
//             resetBooleanKey: true,
//             resetColorKey: true,
//           };
//           artworkJson.materialDetails = await clearAllMaterialDetailsKey(dataToPass);
//         }
//         roomJson = artworkJson;
//       }
//       // }
//       const json_data = JSON.stringify(roomJson);
//       const roomJsonBlob = new Blob([json_data], { type: 'application/json' });
//       if (roomJsonBlob) {
//         const payloadForJson = {
//           id: allCombinations[i].id,
//           json_file: roomJsonBlob,
//         };
//         await updateRetailAutomationArtwork(payloadForJson);
//       }
//     }
//   }

//   callback?.();
// };

export const getLinkedPropTransformData = async () => {
  const allTemplates = selectAllTemplates(getAppState());
  const automationSets = selectAutomationSets(getAppState());
  const { activeTemplateId } = selectActiveSetDetails(getAppState());
  const selectedSet = automationSets.find((data) => data.selected);
  const activeHotspot = selectedSet?.setSteps?.[0]?.subLevels.find(
    (data) => data.active && data.is_enable
  );
  const linkedProp = activeHotspot?.json_data?.linked_prop_object_name;
  const selectedTemplate = allTemplates?.find((val) => val.id === activeTemplateId);
  let linkedPropTransformData = {};
  if (selectedTemplate?.room_file) {
    let jsonValue = await getJson(selectedTemplate?.room_file);
    linkedPropTransformData = jsonValue?.transformChangedObjectData[linkedProp];
  }
  delete linkedPropTransformData['objectName'];
  return linkedPropTransformData;
};

export const getPropCountInit = async (selectedHotspot, productId) => {
  const allTemplates = selectAllTemplates(getAppState());
  const { activeTemplateId } = selectActiveSetDetails(getAppState());
  if (selectedHotspot?.json_data?.linked_prop_object_id) {
    if (parseInt(selectedHotspot?.json_data?.linked_prop_object_id) === productId) {
      const ids = selectedHotspot?.json_data?.linked_prop_object_name?.split('@');
      return parseInt(ids[0]) - 1;
    } else {
      const selectedTemplate = allTemplates?.find((val) => val.id === activeTemplateId);
      if (selectedTemplate?.room_file) {
        let jsonValue = await getJson(selectedTemplate?.room_file);
        const count = jsonValue?.blenderAssetBundleDatas?.filter(
          (val) => parseInt(val.id) === productId
        )?.length;
        return count;
      }
    }
  }
};

export const getVariantsForArtworkJsonForProductVariant = async (ids) => {
  let mainVariantList = [];
  let onlyIds = [];
  for (let i = 0; i < ids?.length; i++) {
    let idToProcess = ids[i];
    if (typeof idToProcess === 'string' && ids[i].includes('@')) {
      idToProcess = ids[i].split('@')[1];
    }
    onlyIds.push(idToProcess);
  }
  onlyIds = onlyIds?.filter(function (item, pos) {
    return onlyIds.indexOf(item) == pos;
  });
  const productDetails =
    onlyIds?.length > 0
      ? (await fetchAllPages((page) => propsReadApi(onlyIds, page)))?.results
      : [];
  for (let i = 0; i < productDetails?.length; i++) {
    mainVariantList.push({
      id: productDetails[i]?.id?.toString(),
      isProductVariant: productDetails?.[i]?.is_product_variant,
    });
  }
  return { productVariantData: mainVariantList, allProps: productDetails };
};

export const getVariantsForArtworkJson = async (ids, returnIsVariant) => {
  let mainVariantList = [];
  let isVariant = false;
  let onlyIds = [];
  for (let i = 0; i < ids?.length; i++) {
    let idToProcess = ids[i];
    if (typeof idToProcess === 'string' && ids[i].includes('@')) {
      idToProcess = ids[i].split('@')[1];
    }
    onlyIds.push(idToProcess);
  }
  onlyIds = onlyIds?.filter(function (item, pos) {
    return onlyIds.indexOf(item) == pos;
  });
  const productDetails = (await fetchAllPages((page) => propsReadApi(onlyIds, page)))?.results;
  for (let i = 0; i < productDetails?.length; i++) {
    isVariant = productDetails?.[i]?.is_product_variant;
    if (productDetails?.[i]?.is_product_variant) {
      mainVariantList.push(productDetails[i]?.id?.toString());
    }
  }
  const finalResult = [];
  for (let i = 0; i < ids?.length; i++) {
    let idToProcess = ids[i];
    if (typeof idToProcess === 'string' && ids[i].includes('@')) {
      idToProcess = ids[i].split('@')[1];
    }
    if (mainVariantList?.includes(idToProcess)) {
      finalResult.push(ids[i]);
    }
  }
  if (returnIsVariant) {
    return isVariant;
  } else {
    return finalResult;
  }
};

export const updateIdsForObject = async (
  object,
  isProductBuilder = false,
  isRetailAutomation = false
) => {
  const propJson = await getGroupPropJsonFile();
  let file_data = { ...propJson.raw };
  if (isProductBuilder) {
    file_data.isProductBuilder = true;
  }

  // if (isRetailAutomation) {
  //   // only send filename, and keep blob for Presigned Api Call
  //   object['product_file'] = object.name;
  //   object['blob_file'] = blob;
  // } else {
  //   // keep sending full blob
  //   object['product_file'] = blob;
  // }

  if (!isRetailAutomation) {
    const json_data = JSON.stringify(file_data);
    const blob = new Blob([json_data], { type: 'application/json' });

    // keep sending full blob
    object['product_file'] = blob;
  }

  addIdsToRequestData({
    data: object,
    roomInfo: propJson.raw,
  });

  if (isProductBuilder) {
    return object;
  }

  const texturesUsed = object.textures;
  if (texturesUsed?.length) {
    const query = texturesUsed.map((a) => `id=${a}`).join('&');

    try {
      const getMappedTexturesResponse = await apiGetLOAMappedTextures(query);
      const getMappedTextures = getMappedTexturesResponse.data;
      object.textures = getMappedTextures.map((a) => a.id);

      file_data.materialDetails = file_data.materialDetails.map((md, i) => {
        const modifiedMd = { ...md };
        ['diffuseId', 'AOId', 'metallicId', 'normalId', 'roughnessId', 'transparencyId'].forEach(
          (key) => {
            if (modifiedMd[key]) {
              modifiedMd[key] =
                getMappedTextures.find(
                  (a) => a.live_on_app_parent.toString() === md[key].toString()
                )?.id || md[key];
            }
          }
        );
        return modifiedMd;
      });
    } catch (error) {
      LogCurator('loa error: ', error);
      throw error;
    }
  }

  if (isRetailAutomation) {
    // moved this code below -> because we are updating the "material_details in file_data"
    // only send filename, and keep blob for Presigned Api Call
    const json_data = JSON.stringify(file_data);
    const blob = new Blob([json_data], { type: 'application/json' });

    object['product_file'] = object.name;
    object['blob_file'] = blob;
  }

  return object;
};

export const updateHotspotProductJsonFile = async ({ data }) => {
  const currentSelectedProduct = selectCurrentSelectedProduct(getAppState());
  const id = currentSelectedProduct?.id;
  const allHotspotProucts = selectHotSpotProducts(getAppState());
  if (id) {
    const jsonBlob = new Blob([JSON.stringify(data)], {
      type: 'application/json',
    });
    const payload = {
      json_file: 'json_file.json',
    };
    const response = await updateHotspotProductApi({ id, payload });
    let allProducts = JSON.parse(JSON.stringify(allHotspotProucts));
    let currentHotspot = allProducts?.[response?.retail_hotspot];
    if (currentHotspot?.length) {
      for (let i = 0; i < currentHotspot?.length; i++) {
        if (currentHotspot[i].id === response.id) {
          currentHotspot[i]['json_file'] = response.json_file;
        }
      }
      dispatcher(retailAutomationActions.updateHotSpotProducts(allProducts));
    }
    if (response?.presigned_data_json_file) {
      apiPostImageOnPresignedData(jsonBlob, response.presigned_data_json_file);
    }
  }
};

export const getRoomJsonBlob = async () => {
  const { activeTemplateId } = selectActiveSetDetails(getAppState());
  const roomJson = await mergeJson(activeTemplateId);
  const defaultArtworksLocal = selectArtworkDefaultCombinations(getAppState());
  const selectedVariationObjectName = selectSelectedVariationProd(getAppState());
  let allUniqueVariations = defaultArtworksLocal?.item?.filter(
    (thing, index, self) =>
      self.findIndex((t) => t.variationObjectName === thing.variationObjectName) === index
  );
  allUniqueVariations = allUniqueVariations?.map((data) => data.variationObjectName);
  roomJson.variants = [];
  // roomJson.variants = allUniqueVariations;
  // roomJson.variants = await getVariantsForArtworkJson(roomJson.variants);
  const variant_prop_name =
    allUniqueVariations?.find((_item) => _item.includes(selectedVariationObjectName)) ||
    `${selectedVariationObjectName}`;
  roomJson.current_linked_prop_object_name = variant_prop_name;

  const json_data = JSON.stringify(roomJson);
  const roomJsonBlob = new Blob([json_data], { type: 'application/json' });
  return roomJsonBlob;
};

export const updateOnlyVariantInDefaultJson = async (artworkData) => {
  const roomJson = await getJson(artworkData?.json_file);
  const defaultArtworksLocal = selectArtworkDefaultCombinations(getAppState());
  const selectedVariationObjectName = selectSelectedVariationProd(getAppState());
  let allUniqueVariations = defaultArtworksLocal?.item?.filter(
    (thing, index, self) =>
      self.findIndex((t) => t.variationObjectName === thing.variationObjectName) === index
  );
  allUniqueVariations = allUniqueVariations?.map((data) => data.variationObjectName);
  roomJson.variants = [];
  // roomJson.variants = allUniqueVariations;
  // roomJson.variants = await getVariantsForArtworkJson(roomJson.variants);

  const json_data = JSON.stringify(roomJson);
  const roomJsonBlob = new Blob([json_data], { type: 'application/json' });
  return roomJsonBlob;
};

export const getUpdatedTextureAfterDuplicate = async (
  texturesCopy,
  newDefaultData,
  artworkData,
  isDefault,
  updateArtworkTexture
) => {
  const textures = JSON.parse(JSON.stringify(texturesCopy));
  // get previous and current mat object name from unity
  // based on previous entry (match it from api response), update the current entry to api

  const afterDuplicateResponse = await waitForEventOnce(
    UnityEvent.OnReceiveObjectDataForDuplicatedRetailProp,
    () => window.roomModule.GetObjectDataForDuplicatedRetailPropReceiver()
  );

  const automationSets = selectAutomationSets(getAppState());
  const selectedSet = automationSets.find((data) => data.selected);
  const activeHotspot = selectedSet?.setSteps?.[0]?.subLevels.find(
    (data) => data.active && data.is_enable
  );

  const payload = {
    hotspot: activeHotspot?.id,
    retail_set: selectedSet?.id,
    texture_data: [],
  };
  const allJsonValues = [];
  if (isDefault) {
    for (let i = 0; i < textures?.length; i++) {
      const currentMatName = textures[i].material_properties.materialName;
      const foundedMatObj = afterDuplicateResponse?.find(
        (data) => data?.previousMatName === currentMatName
      );
      const foundedMatProperty = newDefaultData?.find(
        (data) => data?.materialName === foundedMatObj?.currentMatName
      );
      const obj = {
        id: textures[i]?.id,
        seq_no: textures[i].seq_no,
        name: foundedMatProperty?.id,
        texture_type: textures[i].texture_type,
        artwork_id: artworkData?.id,
        is_default: textures[i].is_default,
        texture_id: textures[i].texture,
        material_id: textures[i].material,
        color_code: textures[i].color_code,
        material_properties: foundedMatProperty,
        thumb: foundedMatProperty?.id,
      };
      payload?.texture_data?.push(obj);
    }
  } else {
    await Promise.all(
      textures?.map(async (textureData, index) => {
        if (textureData?.json_file) {
          const textureJson = await getJson(textureData?.json_file);
          const currentMatName = textureJson.materialName;
          const foundedMatObj = afterDuplicateResponse?.find(
            (data) => data?.previousMatName === currentMatName
          );
          textureJson['materialName'] = foundedMatObj?.currentMatName;
          textureJson['objectName'] = foundedMatObj?.currentObjectName;
          textureJson['blenderObjectName'] = foundedMatObj?.currentObjectName;
          const obj = {
            id: textureData?.id,
            seq_no: textureData.seq_no,
            name: textureData?.name,
            texture_type: textureData.texture_type,
            artwork_id: artworkData?.id,
            is_default: textureData.is_default,
            texture_id: textureData.texture,
            material_id: textureData.material,
            color_code: textureData.color_code,
            thumb: textureData?.name,
            json_file: `${foundedMatObj?.currentMatName}.json`?.replaceAll(' ', '_'),
          };
          const textureJsonBlob = new Blob([JSON.stringify(textureJson)], {
            type: 'application/json',
          });
          const file = await blobUrlToFile(textureData.thumb, textureData?.name);
          allJsonValues.push({ id: obj.id, jsonBlob: textureJsonBlob, imageFile: file });
          payload?.texture_data?.push(obj);
        }
      })
    );
  }
  // update artwork json
  let roomJsonBlob = await getRoomJsonBlob();
  if (isDefault && artworkData?.json_file) {
    roomJsonBlob = await updateOnlyVariantInDefaultJson(artworkData);
    const payloadForJson = {
      id: artworkData?.id,
      json_file: roomJsonBlob,
    };
    await updateRetailAutomationArtwork(payloadForJson);
  }
  // update the textures
  const response = await updateArtworkTexture({
    id: textures?.[0].id, 
    payload
  });
  if (response?.data?.length) {
    // update thumbnails and json
    if (isDefault) {
      await Promise.all(
        response?.data?.map(async (a, i) => {
          const thumbnailObj = newDefaultData?.find((data) => data?.id === a.name);
          if (thumbnailObj?.thumbnail) {
            const file = await blobUrlToFile(thumbnailObj.thumbnail, a.name);
            await apiPostImageOnPresignedData(file, a.presigned_data_thumb);
          }
        })
      );
    } else {
      await Promise.all(
        response?.data?.map(async (a, i) => {
          const currentObj = allJsonValues?.find((data) => data.id === a.id);
          await Promise.all([
            apiPostImageOnPresignedData(currentObj?.imageFile, a.presigned_data_thumb),
            apiPostImageOnPresignedData(currentObj?.jsonBlob, a.presigned_data_json_file),
          ]);
        })
      );
    }
    return response?.data;
  } else {
    return [];
  }
};

// export const getMaterialInfo = (matName, retailAutomationModule) => {
//   // const material = matName[0];
//   for (let i = 0; i < matName.length; i++) {
//     retailAutomationModule.GetDefaultMaterialDataByMaterialNameForRetailAutomation(matName[i]);
//     // asking unity to send the default material image for the product
//     retailAutomationModule.SendBase64DiffuseImageDataByMaterialNameForRetailAutomationReceiver(
//       matName[i]
//     );
//   }
//   return '';
// };

export const getMaterialInfo = (matNames = [], retailAutomationModule, objectName = '') => {
  if (!Array.isArray(matNames) || matNames.length === 0 || !retailAutomationModule) return;

  // Get list of already fetched materials from localStorage
  let materialsFetched = JSON.parse(sessionStorage.getItem('materialsFetched')) || [];

  // Filter out already fetched materials
  const newMaterials = matNames.filter((name) => !materialsFetched.includes(name));
  if (newMaterials.length === 0) return;

  // Update materialsFetched and store in localStorage
  materialsFetched = [...materialsFetched, ...newMaterials];
  sessionStorage.setItem('materialsFetched', JSON.stringify(materialsFetched));

  // Call Unity API with only new materials
  retailAutomationModule.GetDefaultMaterialDataByMaterialNameForRetailAutomation({
    objectName: objectName,
    materialNames: newMaterials,
  });
};

export const replaceKeyInObject = (obj, target, replacement) => {
  // If the object is an array, process each item individually
  if (Array.isArray(obj)) {
    return obj.map((item) => replaceKeyInObject(item, target, replacement));
  }

  // If it's an object, process its keys and values
  if (obj && typeof obj === 'object') {
    const newObj = {};

    for (const key in obj) {
      // Check if the key contains the target as a substring
      const newKey = key.includes(target) ? key.replace(new RegExp(target, 'g'), replacement) : key;

      // If the value is a string or number that matches the target, replace it
      let newValue = obj[key];

      // Check if the value is a string or number and compare it to target (both string and integer)
      if (typeof newValue === 'string') {
        if (newValue === target || parseInt(newValue) === parseInt(target)) {
          newValue = replacement;
        }
        // Also check for substring matching in value
        if (newValue.includes(target)) {
          newValue = newValue.replace(new RegExp(target, 'g'), replacement);
        }
      } else if (typeof newValue === 'number') {
        if (newValue === target || parseInt(newValue) === parseInt(target)) {
          newValue = replacement;
        }
      }

      // Recursively replace nested values
      newObj[newKey] = replaceKeyInObject(newValue, target, replacement);
    }

    return newObj;
  }

  // Return the value if it's neither an object nor an array
  // Check if it's a value that matches the target (string or integer) and should be replaced
  if (obj === target) {
    return replacement;
  }

  return obj;
};
